import React from "react";
import { Label } from "semantic-ui-react";
import { bool, number, shape, string } from "prop-types";

const ProductLineShape = shape({
  active: bool,
  composite_id: string,
  count: number,
  name: string,
  productLineGroup: string
});

function ProductLineLabel({ productLine }) {
  return (
    <Label
      as="span"
      basic={!productLine.active}
      color={productLine.active ? "grey" : null}
    >
      {productLine.name}
    </Label>
  );
}

ProductLineLabel.propTypes = {
  productLine: ProductLineShape.isRequired
};

export default ProductLineLabel;
